var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fragment',[_c('div',{staticClass:"grid"},_vm._l((_vm.data),function(item){return _c('app-view-grid-item',{key:item.id,attrs:{"fields":_vm.fields,"filter":_vm.filter,"item":item,"can":_vm.can}})}),1),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }